/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-params */

import * as React from 'react';
import { currency } from '/client/src/constants/';
import { format } from '/client/src/utils/amountTransformation';
import { PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';


export const columns = (
  rowsFilter: {} | null,
  showPaymentModal?: any,
  handleShowPaymentModal?: any,
  handleShowPaymentModalOrderId?: any,
  showPaymentPurchaseModal?: any,
  handleShowPaymentPurchaseModal?: any,
  editRow: {},
  rowsOrg: {},
  toggleEdit: () => void,
  onHandleFindAndReplaceRowData: () => void,
  sponsors: [],
  setRowsOrg: () => void,
  isNeedShowConfirm: () => void,
  ValidateByEmpty: () => void
): [] => {
  const style = {
    border: '1px solid #cecece',
    borderRadius: '4px',
    lineHeight: '20px',
    padding: '4px .5rem',
    width: '100%'
  };

  const context = React.useContext(EventDetailContainerContext);
  const isReadonlyPermission = _.get(context, 'eventDetail.permission', 'Write') === 'Read';
  const time_zone_id = _.get(context, 'eventDetail.time_zone_id', '');

  return [
    {
      selector: '',
      name: '',
      sortable: false,
      type: 'c0',
      sortType: 0,
      cell: (row: {}): React.Element => {
        if (isReadonlyPermission) return null;
        return (
          <span className={editRow && +row.id === +_.get(editRow, 'id', 0) ? '' : 'showOnHover'}>
            {(+row.id !== +_.get(editRow, 'id', 0)) ?
              <i
                className="icon icon-pencil"
                style={{
                  color: '#e22853',
                  fontSize: '16px'
                }}
                onClick={() => {
                  // const _row = _.clone(row);
                  //
                  // toggleEdit(row);
                  // setRowsOrg(_row);

                  if (_.size(editRow) && _.size(rowsOrg) && isNeedShowConfirm(editRow, rowsOrg)) {
                    // trigger open confirm modal when click in the same handler
                    $('body').click();
                  }

                  if (!_.size(editRow) && !_.size(rowsOrg) || !isNeedShowConfirm(editRow, rowsOrg)) {
                    const _row = _.clone(row);

                    toggleEdit(row);
                    setRowsOrg(_row);
                  }
                }}
              /> :
              <i
                className="icon icon-save"
                style={{
                  color: '#e22853',
                  fontSize: '16px'
                }}
                onClick={async () => {
                  const isValid = ValidateByEmpty();

                  if (_.isString(isValid)) {
                    context.handleShowSystemDialog(true, {
                      systemDialogType: 'error',
                      systemDialogTitle: 'Oops',
                      systemDialogContent: isValid
                    });
                  } else {
                    CssPinner(document.body, true);

                    try {
                      await PUT(`/api/v1/1/events/${row.event_id}/orders/${row.id}/customer`, {
                        email_address: editRow.customer_email_address,
                        first_name: editRow.customer_first_name,
                        last_name: editRow.customer_last_name,
                        phone_number: editRow.customer_phone_number,
                        sponsor_id: editRow.sponsor_id
                      });
                    } catch (e) {
                      console.error(e);
                      context.handleShowSystemDialog(true, {
                        systemDialogType: 'error',
                        systemDialogTitle: 'Oops',
                        systemDialogContent: 'Can\'t save'
                      });
                    }

                    CssPinner(document.body, false);
                    toggleEdit(null);
                    setRowsOrg({});
                  }
                }}
              />
            }
          </span>
        );
      }
    },
    {
        selector: 'customer_first_name',
        name: 'First Name',
        sortable: true,
        cell: (row: {}): React.Element<'div'> => {
          const [fName, setFName] = React.useState(row.customer_first_name);

          if (!editRow || +row.id !== +editRow.id) {
            return (
              <>
                <i
                  className='glyphicon glyphicon-info-sign'
                  style={{
                    marginRight: '.5rem'
                  }}
                  onClick={(): any => {
                    handleShowPaymentModal(!showPaymentModal);
                    handleShowPaymentModalOrderId(row.id);
                  }}
                />
                {row.customer_first_name}
              </>
            );
          }

          return (
            <input
              type="text"
              value={fName}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  customer_first_name: fName,
                  customer_last_name: row.customer_last_name,
                  customer_email_address: row.customer_email_address,
                  customer_phone_number: row.customer_phone_number
                }, 'isPayment');
              }}
              onChange={(e: any) => {
                setFName(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'customer_last_name',
        name: 'Last Name',
        sortable: true,
        cell: (row: {}): React.Element<'div'> => {
          const [lName, setLName] = React.useState(row.customer_last_name);

          if (!editRow || +row.id !== +editRow.id) {
            return lName;
          }

          return (
            <input
              type="text"
              value={lName}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  customer_first_name: row.customer_first_name,
                  customer_last_name: lName,
                  customer_email_address: row.customer_email_address,
                  customer_phone_number: row.customer_phone_number
                }, 'isPayment');
              }}
              onChange={(e: any) => {
                setLName(e.target.value);
              }}
            />
          );
        }
    },
    {
      selector: 'sponsor.name',
      name: 'Sponsor',
      sortable: true,
      cell: (row: {}): React.Element<'div'> => {
        // const [sponsor, setSponsor] = React.useState(row.sponsor_name || '');
        const [sponsorId, setSponsorId] = React.useState(row.sponsor_id || null);

        if (!editRow || row.id.toString() !== editRow.id.toString()) {
          return _.get(row, 'sponsor_name', '');
        }

        React.useEffect(() => {
          onHandleFindAndReplaceRowData(row, {
            first_name: row.first_name,
            last_name: row.last_name,
            email_address: row.email_address,
            remark: row.remark,
            sponsor_id: sponsorId,
            sponsor_name: _.get(_.find(sponsors, (s: {}): string => s.id === sponsorId), 'name', '')
          });
        }, [sponsorId]);

        return (
          <select
            value={sponsorId || ''}
            style={style}
            onChange={(e: any) => {
              setSponsorId(e.target.value);
            }}
          >
            <option value='' />
            {_.map(sponsors, (s: {}, si: number): React.Element<'option'> => {
              return (
                <option
                  value={s.id}
                  key={`sponsorItem-${si}-${s.id}`}
                >{s.name}</option>);
            })}
          </select>
        );
      },
      type: 'c27',
      sortType: 27
    },
    {
        selector: 'creation_time',
        name: 'Date Purchased',
        sortable: true,
        cell: (row: {}): React.Element => {
          return (
            <span
              onClick={(): any => {
                handleShowPaymentPurchaseModal(!showPaymentPurchaseModal);
                handleShowPaymentModalOrderId(row.id);
              }}
              style={{
                color: '#0099FF'
              }}
            >
               {convertToLocalTime(_.get(row, 'creation_time', ''), time_zone_id, 'MM/DD/YY h:mm a z')}
            </span>
          );
        }
    },
    {
        selector: 'customer_email_address',
        name: 'Email',
        sortable: true,
        cell: (row: {}): React.Element<'div'> => {
          const [email, setEmail] = React.useState(row.customer_email_address);

          if (!editRow || +row.id !== +editRow.id) {
            return email;
          }

          return (
            <input
              type="email"
              value={email}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  customer_first_name: row.customer_first_name,
                  customer_last_name: row.customer_last_name,
                  customer_email_address: email,
                  customer_phone_number: row.customer_phone_number
                }, 'isPayment');
              }}
              onChange={(e: any) => {
                setEmail(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'customer_phone_number',
        name: 'Phone',
        sortable: true,
        cell: (row: {}): React.Element<'div'> => {
          const [phone, setPhone] = React.useState(row.customer_phone_number);

          if (!editRow || +row.id !== +editRow.id) {
            return phone;
          }

          return (
            <input
              type="tel"
              value={phone}
              style={style}
              onBlur={() => {
                onHandleFindAndReplaceRowData(row, {
                  customer_first_name: row.customer_first_name,
                  customer_last_name: row.customer_last_name,
                  customer_email_address: row.customer_email_address,
                  customer_phone_number: phone
                }, 'isPayment');
              }}
              onChange={(e: any) => {
                setPhone(e.target.value);
              }}
            />
          );
        }
    },
    {
        selector: 'amount',
        name: 'Total Paid',
        sortable: true,
        cell: (row: any): any => {
          // return `${currency[row.currency]}${row.sparxo_fee || 0}`;
          return format(currency[row.currency], row.amount);
        }
    },
    {
        selector: 'payout',
        name: 'Payout',
        sortable: true,
        cell: (row: any): any => {
          // return `${currency[row.currency]}${row.sparxo_fee || 0}`;
          return format(currency[row.currency], row.payout);
        }
    },
    {
        selector: 'donation_amount',
        name: 'Total Donation',
        sortable: true,
        cell: (row: any): any => {
          return format(currency[row.currency], row.donation_amount);
        }
    },
    {
        selector: 'merchant_donation_revenue',
        name: 'Net Donation',
        sortable: true,
        cell: (row: any): any => {
          return format(currency[row.currency], row.merchant_donation_revenue);
        }
    },
    {
        selector: 'customer_zip_code',
        name: 'Postal Code',
        sortable: true,
        cell: (row: any): any => {
          return `${row.customer_zip_code || ''}`;
        }
    },
    {
        selector: 'amount_refund',
        name: 'Refund',
        sortable: true,
        cell: (row: any): any => {
          return format(currency[row.currency], row.amount_refund);
        }
    },
    {
        selector: 'card_last4',
        name: 'Credit Card',
        sortable: true,
        cell: (row: any): any => {
          return `${row.card_last4 || ''}`;
        }
    }
  ];
};
